import React from 'react';
import { Flex, Box } from '@marvelapp/ui';
import PanelSelect from './PanelSelect';
import * as units from '../../constants/measurementUnits';
import * as code from '../../constants/code';
import * as colorModes from '../../constants/colorModes';
var unitOptions = [
    {
        value: units.PIXEL,
        label: units.LABELS[units.PIXEL],
    },
    {
        value: units.POINT,
        label: units.LABELS[units.POINT],
    },
    {
        value: units.DENSITY_INDEPENDENT_PIXEL,
        label: units.LABELS[units.DENSITY_INDEPENDENT_PIXEL],
    },
];
var codeOptions = [
    { value: code.CSS, label: code.LABELS[code.CSS] },
    { value: code.ANDROID, label: code.LABELS[code.ANDROID] },
    { value: code.SWIFT, label: code.LABELS[code.SWIFT] },
    { value: code.OBJECTIVE_C, label: code.LABELS[code.OBJECTIVE_C] },
];
var guideOptions = [
    { value: 'PERCENTAGES', label: 'Percentage based' },
    { value: 'UNITS', label: 'Unit based' },
];
var colourFormatOptions = [
    { value: colorModes.HEX, label: colorModes.HEX },
    { value: colorModes.RGBA, label: colorModes.RGBA },
];
export default function PanelFormatSettings(_a) {
    var arePercentageGuidesEnabled = _a.arePercentageGuidesEnabled, changeColorMode = _a.changeColorMode, changeMeasurementUnit = _a.changeMeasurementUnit, colorMode = _a.colorMode, currentLang = _a.currentLang, disablePercentageGuides = _a.disablePercentageGuides, enablePercentageGuides = _a.enablePercentageGuides, setCurrentLang = _a.setCurrentLang, unit = _a.unit;
    var isCurrentLangCSS = currentLang === code.CSS;
    var onGuideChange = function (option) {
        if (option === 'PERCENTAGES') {
            enablePercentageGuides();
        }
        else {
            disablePercentageGuides();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { marginBottom: 3 },
            React.createElement(Box, { width: 1 / 4 },
                React.createElement(PanelSelect, { label: "Units", onChange: changeMeasurementUnit, options: unitOptions, testId: "units-option", value: unit })),
            React.createElement(Box, { width: 1 / 2 },
                React.createElement(PanelSelect, { label: "Guides", onChange: onGuideChange, options: guideOptions, testId: "guides-option", value: arePercentageGuidesEnabled ? 'PERCENTAGES' : 'UNITS' }))),
        React.createElement(Flex, { marginBottom: 3 },
            React.createElement(Box, { width: isCurrentLangCSS ? 1 / 4 : 1 / 2 },
                React.createElement(PanelSelect, { label: "Code", onChange: setCurrentLang, options: codeOptions, testId: "code-option", value: currentLang })),
            isCurrentLangCSS && (React.createElement(Box, { width: 1 / 2 },
                React.createElement(PanelSelect, { label: "Colour Format", onChange: changeColorMode, options: colourFormatOptions, testId: "colour-format-option", value: colorMode }))))));
}
